import React__default, { useState, useLayoutEffect } from 'react';
import { d as dist } from './index-bd7e9b86.js';
import _s from 'styled-components';
import Box from './Box.js';
import { I as InlineNotification } from './notification-785219c0.js';
import './core.esm-901288dd.js';
import './_commonjsHelpers-357b3b4e.js';
import './inheritsLoose-6f2ea841.js';
import 'react-dom';
import './assertThisInitialized-db62c3c4.js';
import './objectWithoutPropertiesLoose-6737dabb.js';
import './index-5fd269e1.js';
import './index-48edd52c.js';
import './index-a67b9a05.js';
import './useTheme.js';
import './Icon.js';
import './global-2e5d81b9.js';
import './IconButton.js';
import './LinkButton.js';
import './Typography.js';

const styled = typeof _s === "object" && "default" in _s ? _s.default : _s;
const Toast = ({
  appearance = 'info',
  children: notificationProps,
  transitionState,
  onDismiss
}) => {
  const {
    descriptionText,
    testID,
    titleText
  } = notificationProps;
  const [unbounceBannerThreshold, setUnbounceBannerThreshold] = useState(0);
  useLayoutEffect(() => {
    var _a;
    const banner = document.getElementsByClassName('ub-emb-bar-frame')[0];
    if (banner) {
      setUnbounceBannerThreshold((_a = banner === null || banner === void 0 ? void 0 : banner.clientHeight) !== null && _a !== void 0 ? _a : 0);
      const closeButton = document.getElementsByClassName('ub-emb-close')[0];
      if (closeButton) {
        closeButton.addEventListener('click', () => {
          setUnbounceBannerThreshold(0);
        });
      }
    }
  }, []);
  return /*#__PURE__*/React__default.createElement(Container, {
    "data-state": transitionState,
    unbounceBannerThreshold: unbounceBannerThreshold
  }, /*#__PURE__*/React__default.createElement(Box, {
    width: "400px",
    marginBottom: "tiny"
  }, /*#__PURE__*/React__default.createElement(InlineNotification, {
    descriptionText: descriptionText,
    testID: testID,
    titleText: titleText,
    variant: appearance,
    onRequestToClose: onDismiss
  })));
};
const Container = styled.div`
  margin-top: ${({
  unbounceBannerThreshold
}) => unbounceBannerThreshold}px;
  transform: translateX(100%);
  transition: transform 0.25s ease;
  z-index: 1;

  &[data-state='entered'] {
    transform: translateX(0);
    transition: transform 0.25s ease;
  }
`;

const NotificationProvider = ({
  children
}) => /*#__PURE__*/React__default.createElement(dist.ToastProvider, {
  autoDismiss: true,
  autoDismissTimeout: 5000,
  components: {
    Toast
  },
  placement: "top-right"
}, children);

export { NotificationProvider as default };
//# sourceMappingURL=NotificationProvider.js.map
